// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"CastomTooltip_tooltipContainer__PDVct","tooltip":"CastomTooltip_tooltip__GcLy4","hintIcon":"CastomTooltip_hintIcon__sU1pT"};